const debugKey = "_SGDX_DEBUG_ENABLED_";

declare global {
  interface Window {
    [debugKey]: unknown;
  }
}

export const isDebugEnabled = () => {
  if (!window[debugKey] && document.location.search.includes(debugKey)) {
    localStorage.setItem(debugKey, debugKey);
  }
  window[debugKey] ??= localStorage.getItem(debugKey);
  return window[debugKey];
};

export const debug = (...args: any[]) => {
  if (!isDebugEnabled()) return;
  console.log(...args);
};
